/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Size_SubtitleInputs */

const vi_lot_size_subtitle = /** @type {(inputs: Lot_Size_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cấu hình khối lượng mặc định (kg/lô) cho 3 công đoạn pipeline.`)
};

/**

* @param {Lot_Size_SubtitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_size_subtitle = /** @type {((inputs?: Lot_Size_SubtitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Size_SubtitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_size_subtitle(inputs)
});